import React, { useMemo } from "react";
import { PageBuilderAccordionTextFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import { BackgroundColor } from "types/componentBackground";
import { isPresent } from "src/utils/checks";
import { cardColorForBackground } from "./pageBuilderRenderHelper";
import { Accordion, AccordionItem } from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";

export interface PageBuilderAccordionTextProps
  extends PageBuilderAccordionTextFragment {
  backgroundColor: BackgroundColor;
}

const PageBuilderAccordionText: React.FC<
  React.PropsWithChildren<PageBuilderAccordionTextProps>
> = ({ heading, items = [], backgroundColor }) => {
  const cardBackgroundColor = cardColorForBackground(backgroundColor);

  const accordinItems = useMemo(() => {
    return items
      .map((item) => {
        if (!item) return null;
        const { title, content, _key } = item;
        if (!title?.localized || !_key) return null;

        return (
          <AccordionItem
            id={_key}
            key={_key}
            backgroundColor={cardBackgroundColor}
            title={title.localized}
            trackingName={title.localized}
          >
            <TextBox content={content?.localized} fontSize="inherit" />
          </AccordionItem>
        );
      })
      .filter(isPresent);
  }, [cardBackgroundColor, items]);

  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      {accordinItems.length > 0 && (
        <Accordion trackingName="accordion">{accordinItems}</Accordion>
      )}
    </React.Fragment>
  );
};

export default PageBuilderAccordionText;

export const fragments = graphql`
  fragment PageBuilderAccordionText on SanityAccordionText {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }

    items {
      _key
      title {
        localized
      }

      content {
        localized
      }
    }
  }
`;
